<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { paymentService } from "../../../../services/reportservice/paymentservice.js";
import { servicehelpers } from "../../../../services/servicehelpers";


/* eslint-disable no-console */
export default {
  page: {
    title: "Collect Payment Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Input,
    Select, 
  },
  data() {
    return {
      title: "Collect Payment Report",
      data: [],
      date: [],
      projects: {},
      groups: {},
      contractType:[
        {id: 1, label: 'បង់រំលស់'},
        {id: 2, label: 'បង់ជាដំណាក់'},
        {id: 3, label: 'បង់ផ្ដាច់'},
      ],

      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),


      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 1,
      dataContractTypeId: 0,
      dataGroupId: 0,
      dataSearch: '',
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    this.loadingpropertyGroupData(this.dataProjectId);
    
  },
  methods: {
    
     
    loadingData: function() {
      paymentService.getCollectPayment()
        .then(response => {
          this.data = response.data.payment;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projects = response.data.project;
          this.projectName = response.data.project_name;

        });
    },
    loadingpropertyGroupData: function(projectId = 1) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groups = response.data;
      });
    },
    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId+
        '&start_date='+this.dataStartDate+
        '&end_date='+this.dataEndDate+
        '&contract_type_id='+this.dataContractTypeId+
        '&group_id='+this.dataGroupId+
        '&data_search='+this.dataSearch;
      paymentService.getCollectPayment(data)
        .then(response => {
          this.data = response.data.payment;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projectName = response.data.project_name.name+ ' ' + response.data.project_name.name_en;
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    }
  },
  computed: {
    totalPiad() {
      return this.data.reduce(function (sum, item) {
        return sum + item.paid
      }, 0)
    },
    totalIntegerPay() {
      return this.data.reduce(function (sum, item) {
        return sum + item.integer_pay
      }, 0)
    },
    totalInterest() {
      return this.data.reduce(function (sum, item) {
        return sum + item.interest
      }, 0)
    },
    totalPrinciplePay() {
      return this.data.reduce(function (sum, item) {
        return sum + item.principal_pay
      }, 0)
    },
    totalPenalty() {
      return this.data.reduce(function (sum, item) {
        return sum + item.penalty
      }, 0)
    },
  }
};

</script>
<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('report.payment.collect-payment')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              <div class="col-sm-2">
                <label>{{$t('general.search')}}</label>
                <Input 
                  :type="'text'"
                  :id="'data_search'"
                  :placeholder="$t('report.sale-detail.unit')+' / '+$t('customer.name')+' / '+$t('report.daily.phone')"
                  v-model="dataSearch"
                  @enter="submitSearch"
                /> 
              </div>
              <div class="col-sm-2">
                <label>{{$t('project.text')}}</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm">
                <label>{{$t('setting.configuration.contract-template.type')}}</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                   :list="{data: this.contractType}"
                  v-model="dataContractTypeId"
                /> 
              </div>
              <div class="col-sm">
                <label>{{$t('property.group')}}</label>
                <Select
                  :id="'id'"
                  :text="'name'"
                  :editable="true"
                  :list="{data: this.groups}"
                  v-model="dataGroupId"
                /> 
              </div>
              
              <div class="col-sm">
                <label>{{$t('report.payment.pay-date')}}</label>
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="dataStartDate"
                /> 
              </div>
              <div class="col-sm">
                <label class="text-white">{{$t('report.payment.pay-date')}}</label>
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="dataEndDate"
                /> 
              </div>
              <div class="col-sm">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom khb">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="35%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 070 55 40 77 | 015 55 40 77 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class="khb"><u>{{$t('report.text')+$t('report.payment.collect-payment')+$t('general.detail')}}</u></p>
                    <p class="khb"><u>ប្រចាំខែ: {{this.dateFormat(date.start_date)}} - {{this.dateFormat(date.end_date)}}</u></p>
                    <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
           <table class="content-general h8 project-sumary-table report-table" width="100%">
              <tbody>
                <tr>
                  <td class="thead" rowspan="2">N<u>o</u></td>
                  <!-- <td class="thead" rowspan="2">{{$t('project.text')}}</td> -->
                  <td class="thead" rowspan="2">{{$t('setting.configuration.contract-template.type')}}</td>
                  <td class="thead" rowspan="2">{{$t('property.text')}}</td>
                  <td class="thead" rowspan="2">{{$t('payment.code')}}</td>
                  <td class="thead" rowspan="2">{{$t('customer.type')}}</td>
                  <td class="thead" rowspan="2">{{$t('report.payment.customer-name')}}</td>
                  <td class="thead" rowspan="2">{{$t('customer.phone-no')}}</td>
                  <td class="thead" rowspan="2">{{$t('report.payment.pay-date')}}</td>
                  <td class="thead" colspan="3">{{$t('report.payment.pay-amount')}}</td>
                  <td class="thead" rowspan="2">{{$t('report.payment.paid-amount')}}</td>
                  <td class="thead" rowspan="2" >{{$t('report.payment.due-amount')}}</td>
                </tr>
                <tr>
                  <td class="thead">{{$t('report.sale-unit.total')}}</td>
                  <td class="thead">{{$t('report.sale-unit.interest')}}</td>
                  <td class="thead">{{$t('report.payment.principle-payment')}}</td>
                </tr>
              
                <tr v-for="(list, index) in data" :key="index" >

                  <td>{{index + 1}}</td>
                  <td>{{list.loan_type_kh}}</td>
                  <td>{{list.property_name}}</td>
                  <td>{{list.code}}</td>
                  <td>{{list.customer_type}}</td>
                  <td>{{list.customer_name}}</td>
                   <td>{{`${list.phone_no_1}` + (list.phone_no_2 !=null? ` / ${list.phone_no_2}` : '')}} </td>
                  <td>{{dateFormat(list.pay_date)}}</td>
                  <td>{{formatCurrency(list.integer_pay)}}</td>
                  <td>{{formatCurrency(list.interest)}}</td>
                  <td>{{formatCurrency(list.principal_pay)}}</td>
                  <td>{{formatCurrency(list.paid)}}</td>
                  <td>{{formatCurrency(list.integer_pay-list.paid)}}</td>
                </tr>
                <tr v-if="data">
                  <td colspan="8" class="tfoot text-end pe-2">{{$t('report.total')}}</td>
                  <td class="tfoot text-center border-start border-dark ps-2">{{formatCurrency(totalIntegerPay)}}</td>
                  <td class="tfoot text-center border-start border-dark ps-2">{{formatCurrency(totalInterest)}}</td>
                  <td class="tfoot text-center border-start border-dark ps-2">{{formatCurrency(totalPrinciplePay)}}</td>
                  <td class="tfoot text-center border-start border-dark ps-2">{{formatCurrency(totalPiad)}}</td>
                  <td class="tfoot text-center border-start border-dark ps-2">{{formatCurrency(totalIntegerPay - totalPiad)}}</td>
                </tr>
              </tbody>
            </table>
          </div>  
          <div class="row mt-3 report-table">
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                  <br><br>

                  <p>លី ប៊ុនហ៊ាង</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកហិរញ្ញវត្ថុ</p>
                  <br><br>

                  <p>លឹម ទ្រី</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                  <br><br>

                  <p>សាយនី យូស៊ន់</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              
              <div class="col-3 mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <br><br>

                  <p></p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col-3">
                <center>
                  <p class="align-right">{{$t('report.income_expense.date')}} {{dateFormat(this.date.do_date)}}<br>អ្នកធ្វើរបាយការណ៍</p>
                    <br><br>
                  <p class="mt-5">{{this.user.name}}</p>

                  </center>
              </div>
          </div>
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>